<template>
  <v-hover v-slot="{ hover }">
    <!-- Favorite -->
    <v-card
      @click="navigateToWork"
      v-ripple
      rounded
      class="favorite d-flex flex-column rounded-xl legacy-review-tile"
      :elevation="hover ? activeHover : initialHover"
    >
      <v-img :src="image" :class="{ hovered: hover }">
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="info"></v-progress-circular>
          </v-row>
        </template>

        <medium-icon :medium="medium" :hover="true" :text="title" class="overlay-icon" />
      </v-img>
    </v-card>
  </v-hover>
</template>

<script>
import { mapMutations } from "vuex";
import getAspectRatio, { hasTallPoster } from "../util/getAspectRatio";

export default {
  name: "favorite-tile",

  data: () => ({
    initialHover: 2,
    activeHover: 5,
  }),

  props: {
    /*
      Full Object
      {
        medium: Medium,
        poster_source: String,
        title: String,
        id: String
      }
    */
    data: { type: Object, default: () => ({}) },

    width: {
      type: [Number, String],
      default: 200,
    },
  },

  computed: {
    medium() {
      return this.data.medium;
    },
    image() {
      return this.data.poster_source || "https://telemonial.com/unknown.png";
    },
    title() {
      return this.data.title;
    },
    id() {
      return this.data.id;
    },
    aspectRatio() {
      return getAspectRatio(this.medium);
    },
    tallPoster() {
      return hasTallPoster(this.medium);
    },
  },

  methods: {
    getAspectRatio,
    hasTallPoster,
    ...mapMutations(["showDrawer", "closeDrawer"]),

    displayDrawer() {
      this.showDrawer({
        status: "review",
        data: this.review,
      });
    },

    createReview() {
      this.$router.push("/rate");
    },

    async navigateToWork() {
      let workId = this.id;
      await this.$router.push({
        name: "work",
        params: {
          medium: this.medium,
          workId: workId,
        },
      });
    },
  },
};
</script>

<style scoped>
.v-card.favorite:hover .medium-icon {
  max-width: calc(100% - 16px) !important;

  background-color: rgba(0, 0, 0, 0.75);
}

.v-card.favorite .medium-icon >>> .span-wrapper {
  overflow: hidden;
  max-width: calc(100% - 40px);
}
</style>
